/**
 * Custom functionality for Service page.
 */

/* global jQuery */

const beforeAfter = require('../components/before-after');

const $ = jQuery;   // jQuery loaded via WordPress enqueue process


function initVideoBlockWatcher() {
    // Watch for video in viewport.
    let videoPlayed = false;
    const videoEl = document.querySelector('.medical__anim-video');
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.target == videoEl && entry.isIntersecting && !videoPlayed) {
                videoEl.play();
                videoPlayed = true;
            }
        });
    }, { threshold: .5 });
    observer.observe(videoEl);
}

exports.init = function() {
    // Service page initialization.  $ is available here...

    // initModule(beforeAfter);
    beforeAfter.init();
    initVideoBlockWatcher();
};

function initModule(mod) {
	// console.log("initModule(): "+mod);
    if ((mod !== null) && (typeof mod !== 'undefined') && (typeof mod.init === 'function')) {
        mod.init();
    }
}